import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import {
    CustomBreadcrumbs,
    CustomFilter,
    CustomList,
    CustomSelectInput,
} from 'candy-commons-components';
import React from 'react';
import { TextField, TextInput, useTranslate } from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import countries from '../../data/countries.json';
import CommonApplianceFilter from '../../components/organisms/commonApplianceFilter';

const MaintenanceGenericList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.maintenance-generic.name'),
            url: '',
            icon: <WorkOutlineIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                perPage={25}
                {...props}
                filters={
                    <CommonApplianceFilter
                        brand
                        optionalFilters={[
                            <CustomSelectInput
                                source="countryCode"
                                allowEmpty
                                alwaysOn
                                choices={countries}
                            />,
                        ]}
                    />
                }
                pagination={<DynamoPagination resource="maintenance-generic" />}
                bulkActionButtons={
                    permissions &&
                    permissions['maintenance-generic'] &&
                    permissions['maintenance-generic'].delete
                }
            >
                <CustomDatagrid selectable rowClick="edit">
                    <TextField source="countryCode" />
                    <TextField source="brand" />
                    <TextField source="link" />
                    <TextField source="country" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};
export default MaintenanceGenericList;
